import { render, staticRenderFns } from "./pdc_in_former.vue?vue&type=template&id=fb4eab30&scoped=true&"
import script from "./pdc_in_former.vue?vue&type=script&lang=js&"
export * from "./pdc_in_former.vue?vue&type=script&lang=js&"
import style0 from "./pdc_in_former.vue?vue&type=style&index=0&id=fb4eab30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4eab30",
  null
  
)

export default component.exports